<div class="form-group" [ngClass]="{'': notMarginTop}">
   <label [for]="label"><span>{{label}}</span></label>
    <input [id]="label"
           [name]="label"
           type="text"
           class="form-control shadow-none"
           [ngClass]="{'c45': !isInvalidInput, 'c45-error': isInvalidInput}"
           [value]="value"
                  [placeholder]="placeholder"
           (input)="onChange($event.target.value)"
           (blur)="onTouched()"
           [disabled]="disabled">
    <small *ngIf="isInvalidInput" class="text-danger"> 
        <span>{{label}} es requerido</span> 
    </small>
</div>
